import React, { useState } from 'react';
import { LabeledInput } from '../../Components';

const ChangePassword = () => {
    const [password, setPassword] = useState({ old: '', newpass: '', confirmpass: '' });
    const handlePassChange = (data, newValue) => {
        setPassword((prev) => {
            const oldData = { ...prev };
            oldData[data] = newValue;
            return oldData;
        });
    };
    return (
        <div className="setting_profile">
            <div className="home_head">
                <h2 className="home_heading">Change Password</h2>
            </div>
            <div className="pass_body">
                <LabeledInput
                    name="password old"
                    value={password.old}
                    changeHandler={(e) => {
                        handlePassChange('old', e.target.value);
                    }}
                    label={'Old Password'}
                    type="password"
                />
                <LabeledInput
                    name="last name"
                    value={password.newpass}
                    changeHandler={(e) => {
                        handlePassChange('newpass', e.target.value);
                    }}
                    label={'New Password'}
                    type="password"
                />

                <LabeledInput
                    name="phone"
                    value={password.confirmpass}
                    changeHandler={(e) => {
                        handlePassChange('confirmpass', e.target.value);
                    }}
                    label={'Confirm New Password'}
                    type="password"
                />
                <div className="footer_setting">
                    <button className="btn-orange">Save Password</button>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
